module.exports = __webpack_public_path__ + "images/emoji/arrow_right_hook.185692cd67fbc28f16e0.png";